"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastPageIcon = exports.NavigateNextIcon = exports.NavigateBeforeIcon = exports.FirstPageIcon = exports.SaveIcon = exports.HelpIcon = exports.CloseIcon = exports.CheckCircleIcon = exports.VisibilityOffIcon = exports.VisibilityIcon = exports.CollapseListIcon = exports.ExpandListIcon = exports.RemoveAllIcon = exports.RemoveElementIcon = exports.RedoIcon = exports.UndoIcon = exports.ReadonlyModeIcon = exports.CropModeIcon = exports.AutoSegmentationModeIcon = exports.RectangleToolIcon = void 0;
var tslib_1 = require("tslib");
var Add_1 = tslib_1.__importDefault(require("@material-ui/icons/Add"));
var Android_1 = tslib_1.__importDefault(require("@material-ui/icons/Android"));
var CheckCircle_1 = tslib_1.__importDefault(require("@material-ui/icons/CheckCircle"));
var Close_1 = tslib_1.__importDefault(require("@material-ui/icons/Close"));
var Crop_1 = tslib_1.__importDefault(require("@material-ui/icons/Crop"));
var Delete_1 = tslib_1.__importDefault(require("@material-ui/icons/Delete"));
var DeleteSweep_1 = tslib_1.__importDefault(require("@material-ui/icons/DeleteSweep"));
var FirstPage_1 = tslib_1.__importDefault(require("@material-ui/icons/FirstPage"));
var Help_1 = tslib_1.__importDefault(require("@material-ui/icons/Help"));
var Image_1 = tslib_1.__importDefault(require("@material-ui/icons/Image"));
var LastPage_1 = tslib_1.__importDefault(require("@material-ui/icons/LastPage"));
var NavigateBefore_1 = tslib_1.__importDefault(require("@material-ui/icons/NavigateBefore"));
var NavigateNext_1 = tslib_1.__importDefault(require("@material-ui/icons/NavigateNext"));
var Redo_1 = tslib_1.__importDefault(require("@material-ui/icons/Redo"));
var Remove_1 = tslib_1.__importDefault(require("@material-ui/icons/Remove"));
var Save_1 = tslib_1.__importDefault(require("@material-ui/icons/Save"));
var Undo_1 = tslib_1.__importDefault(require("@material-ui/icons/Undo"));
var Visibility_1 = tslib_1.__importDefault(require("@material-ui/icons/Visibility"));
var VisibilityOff_1 = tslib_1.__importDefault(require("@material-ui/icons/VisibilityOff"));
var rectangle_tool_icon_1 = require("./icons/rectangle-tool-icon");
Object.defineProperty(exports, "RectangleToolIcon", { enumerable: true, get: function () { return rectangle_tool_icon_1.RectangleToolIcon; } });
exports.AutoSegmentationModeIcon = Android_1.default;
exports.CropModeIcon = Crop_1.default;
exports.ReadonlyModeIcon = Image_1.default;
exports.UndoIcon = Undo_1.default;
exports.RedoIcon = Redo_1.default;
exports.RemoveElementIcon = Delete_1.default;
exports.RemoveAllIcon = DeleteSweep_1.default;
exports.ExpandListIcon = Add_1.default;
exports.CollapseListIcon = Remove_1.default;
exports.VisibilityIcon = Visibility_1.default;
exports.VisibilityOffIcon = VisibilityOff_1.default;
exports.CheckCircleIcon = CheckCircle_1.default;
exports.CloseIcon = Close_1.default;
exports.HelpIcon = Help_1.default;
exports.SaveIcon = Save_1.default;
exports.FirstPageIcon = FirstPage_1.default;
exports.NavigateBeforeIcon = NavigateBefore_1.default;
exports.NavigateNextIcon = NavigateNext_1.default;
exports.LastPageIcon = LastPage_1.default;
